// Translations
import landing from '../views/landing/translations/ua'

// Translation: Terms of service (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
